module.exports = {"320871050":"东湖","320871051":"新港","320871052":"广州路","320871053":"枚乘路","320871055":"金港路","320871056":"张码","320871057":"淮洪路","320871060":"富城路","320871061":"福地路","320871062":"高铁新区","320871150":"范集镇","320871350":"钵池乡","320871351":"徐杨乡","320871352":"南马厂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320871.json
// module id = 903
// module chunks = 0